module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "contents"
  }, [_c('p', [_c('span', [_vm._v("©2017-2019 河北省环境应急与重污染天气预警中心")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin": "0 20px"
    }
  }, [_vm._v("|")]), _vm._v(" "), _c('span', [_vm._v("技术支持：标旗（武汉）信息技术有限公司")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin": "0 20px"
    }
  }, [_vm._v("|")]), _vm._v(" "), _c('span', [_vm._v("版本号：" + _vm._s(_vm.version))])]), _vm._v(" "), _vm._m(0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('span', [_vm._v("主要研发人员：孟宪栋、许政、付贺鹏 ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-20453ade","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/component/Footer.vue
// module id = 1192
// module chunks = 2